import Vue from 'vue'
import questionnaireList from '../questionnaires/index'

const questionnaire = {
  namespaced: true,
  state: {
    allAnswers: [],
    allStashedAnswers: [],
    allQuestions: [],
    hasError: false
  },
  getters: {

  },
  mutations: {
    setErrorState: (state, payload) => {
      state.hasError = payload
    },
    resetQuestionnaire: (state) => {
      Vue.set(state, 'allAnswers', [])
      Vue.set(state, 'allStashedAnswers', [])
      state.hasError = false
    },
    setQuestionnaireFields: (state, assessmentType) => {
      state.allQuestions = questionnaireList[assessmentType]
    },
    setStashedAnswer: (state, payload) => {
      let index
      index = state.allStashedAnswers.findIndex(answer => answer.field.id === payload.field.id)
      if (index === -1) {
        state.allStashedAnswers.push(payload)
      } else {
        state.allStashedAnswers.splice(index, 1)
        state.allStashedAnswers.push(payload)
      }
    }
  },
  actions: {
    updateErrorState ({ commit }, payload) {
      return new Promise(resolve => {
        commit('setErrorState', payload)
        resolve()
      })
    },
    updateStashedAnswers ({ commit }, payload) {
      return new Promise(resolve => {
        commit('setStashedAnswer', payload)
        resolve()
      })
    },
    updateQuestionnaireFields ({ commit }, assessmentType) {
      return new Promise((resolve, reject) => {
        if (typeof (questionnaireList[assessmentType]) !== 'undefined') {
          commit('resetQuestionnaire')
          commit('setQuestionnaireFields', assessmentType)
          resolve()
        } else {
          reject('Failed navigation to formId: ' + assessmentType)
        }
      })
    },
    resetQuestionnaireStoreModule ({ commit }) {
      return new Promise(resolve => {
        commit('resetQuestionnaire')
        resolve()
      })
    }
  }
}

export default questionnaire



// WEBPACK FOOTER //
// ./src/store/modules/questionnaire.js